module.exports = __webpack_public_path__ + "img/rotulacion.8c8d67ad.jpg";